<template>
  <div class="filteritems">
    <filter-button-group v-if="showAll"
                         :filter-items="customerStates"
                         :label="$t('customerSearch.filterCustomerStatusTitle')"
                         :list="list.customerStates"
                         :status="true"
                         :collapsible="true"
                         :isCollapsed="false"
                         @update-list="changeCustomerStatus"
    />
    <filter-button-group :filter-items="customerTypes"
                         :label="$t('customerSearch.filterCustomerTypeTitle')"
                         :list="list.customerTypes"
                         :collapsible="true"
                         @update-list="changeCustomerTypes"
    />

    <div class="groupmembership">
      <sprcol :heading="$t('customerSearch.groupMembership')"
              :fontsize="'15px !important;'"
      >
        <div slot="body">
          <span :class="{ 'filterbutton': true, 'selected': hasGroupMembershipSelected }">
            <sprbutton :title="$t('customerSearch.isMember')"
                       :size="6"
                       :bordersize="2"
                       :value="hasGroupMembershipSelected.toString()"
                       click-event="changeHasGroupMembership"
                       :class="''"
                       @changeHasGroupMembership="changeHasGroupMembership"
            />
          </span>
        </div>
      </sprcol>
    </div>
    <filter-button-group v-if="showAll"
                         :filter-items="genders"
                         :label="$t('customerSearch.gender')"
                         :list="list.genders"
                         :collapsible="true"

                         @update-list="changeGender"
    />
    <filter-button-group v-if="showAll"
                         :filter-items="friendshipTypes"
                         :label="$t('customerSearch.filterFriendshipTypeTitle')"
                         :list="list.friendshipTypes"
                         :collapsible="true"

                         @update-list="changeFriendshipType"
    />

    <filter-button-group :filter-items="languages"
                         :label="$t('customerForm.nativeLanguage')"
                         :list="list.motherTongs"
                         :collapsible="true"

                         @update-list="changeMotherTongs"
    />

    <filter-button-group :filter-items="languages"
                         :label="$t('customerForm.customerLanguages')"
                         :list="list.languages"
                         :collapsible="true"

                         @update-list="changeLanguages"
    />

    <filter-button-group :filter-items="ages"
                         :label="$t('customerSearch.filterAge')"
                         :list="list.ages"
                         :collapsible="true"

                         @update-list="changeAges"
    />
    <filter-button-group v-if="showAll"
                         :filter-items="timeWithoutFriends"
                         :label="$t('customerSearch.timeWithoutFriends')"
                         :list="list.timeWithoutFriends"
                         :collapsible="true"

                         @update-list="changeTimeWithoutFriends"
    />
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'
  import * as _ from 'lodash'
  import sprbutton from '../SPRButton.vue'
  import sprcol from '../SPRCollapsible.vue'

  import filterButtonGroup from '../FilterButtonGroup.vue'
  import { SearchFilter, SearchFilterText } from '../../types/custom'
  import { CustomerTypes, NetCustomerTypes, CustomerState, Interests,
           NetFriendshipTypes, FriendshipTypes, LanguageDto, PreferredAges,
           PreferredGenders, TimeWithoutFriends, OrderByFriendType } from '@/types/index'

  // the data object
  export interface TemplateComponentData {
    list: SearchFilter,
    hasGroupMembershipSelected: boolean
  }

  export default Vue.extend({
    name: 'FilterItems',
    components: { sprbutton, sprcol, filterButtonGroup },
    props: {
      value: {
        type: Object as () => SearchFilter,
        required: true
      },
      showAll: {
        type: Boolean,
        default: false
      },
      filterType: {
        type: String,
        default: 'VOLUNTEER'
      },
      customerTypes: {
        type: Array as () => Array<CustomerTypes> | Array<NetCustomerTypes>,
        default: () => []
      },
      customerStates: {
        type: Array as () => Array<CustomerState>,
        default: () => []
      },
      interests: {
        type: Array as () => Array<Interests>,
        default: () => []
      },
      friendshipTypes: {
        type: Array as () => Array<FriendshipTypes> | Array<NetFriendshipTypes>,
        default: () => []
      },
      languages: {
        type: Array as () => Array<LanguageDto>,
        default: () => []
      },
      ages: {
        type: Array as () => Array<PreferredAges>,
        default: () => []
      },
      genders: {
        type: Array as () => Array<PreferredGenders>,
        default: () => []
      },
      timeWithoutFriends: {
        type: Array as () => Array<TimeWithoutFriends>,
        default: () => []
      }
    },
    data (): TemplateComponentData {
      return {
        list: {
          customerTypes: [],
          customerStates: [],
          genders: [],
          friendshipTypes: [],
          motherTongs: [],
          languages: [],
          ages: [],
          timeWithoutFriends: [],
          interests: [],
          hasGroupMembership: false,
          searchText: {
            customer: '',
            volunteer: ''
          } as SearchFilterText,
          skip: 0,
          pagesize: 10,
          searchType: this.filterType,
          orderByFriendType: OrderByFriendType.NotDefined
        } as SearchFilter,
        hasGroupMembershipSelected: this.$store.state.searchFilter.hasGroupMembership || false
      }
    },
    watch: {
      value (newVal) {
        this.list = newVal
      }
    },
    mounted (): void {
      this.list = this.value
    },
    methods: {

      changeCustomerType: function (id): void {
        this.updateList(this.list.customerTypes, id)
        this.$emit('input', this.list)
      },
      changeCustomerTypes (id) { // Expecting { id, action }
        this.updateList(this.list.customerTypes, id)
        this.$emit('input', this.list) // Update parent model if needed
      },
      changeCustomerStatus: function (id): void {
        this.updateList(this.list.customerStates, id)
        this.$emit('input', this.list)
      },
      changeHasGroupMembership: function (): void {
        this.hasGroupMembershipSelected = !this.hasGroupMembershipSelected
        this.list.hasGroupMembership = this.hasGroupMembershipSelected
        this.$emit('input', this.list)
      },
      changeActivityType: function (id): void {
        this.updateList(this.list.interests, id)
        this.$emit('input', this.list)
      },
      changeFriendshipType: function (id): void {
        this.updateList(this.list.friendshipTypes, id)
        this.$emit('input', this.list)
      },
      changeGender: function (id): void {
        this.updateList(this.list.genders, id)
        this.$emit('input', this.list)
      },
      changeMotherTongs: function (id): void {
        this.updateLanguageList(this.list.motherTongs, id)
        this.$emit('input', this.list)
      },
      changeLanguages: function (id): void {
        this.updateLanguageList(this.list.languages, id)
        this.$emit('input', this.list)
      },
      changeAges: function (id): void {
        this.updateList(this.list.ages, id)
        this.$emit('input', this.list)
      },
      changeTimeWithoutFriends: function (id): void {
        this.updateList(this.list.timeWithoutFriends, id)
        this.$emit('input', this.list)
      },
      updateList: function (list, id): void {
        var existingItemIndex = _.indexOf(list, Number(id))
        if (existingItemIndex >= 0) {
          this.$delete(list, existingItemIndex)
        } else {
          this.$set(list, list.length, Number(id))
        }
      },
      updateLanguageList: function (list, isoCode): void {
        var existingItemIndex = _.indexOf(list, isoCode)
        if (existingItemIndex >= 0) {
          this.$delete(list, existingItemIndex)
        } else {
          this.$set(list, list.length, isoCode)
        }
      },
      isSelected (list, id): boolean {
        return _.indexOf(list, id) >= 0
      }
    }
  })
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/_variables.scss";

  .filteritems {
    .filter-customer-status {
      margin-bottom: 30px;
    }
    .groupmembership {
      padding-bottom: 30px;
    }
    .cap-label {
      margin-bottom: 15px;
      padding:0 5px;

    }

    .filterbutton {
      padding-right:6px;
      margin-bottom: 8px;
      display: inline-block;

      .statefilteritem {
        &:hover {
          color: $brand-white;
        }
        &.filteritem-1 {
          border-color: $state-pendingapproval;
          &:hover {
            background-color: $state-pendingapproval;
          }
        }

        &.filteritem-2 {
          border-color: $state-active;
          &:hover {
            background-color: $state-active;
          }
        }

        &.filteritem-3 {
          border-color: $state-pendingfriend;
          &:hover {
            background-color: $state-pendingfriend;
          }
        }

        &.filteritem-4 {
          border-color: $state-activefriendship;
          &:hover {
            background-color: $state-activefriendship;
          }
        }

        &.filteritem-5 {
          border-color: $state-nonactive;
          &:hover {
            background-color: $state-nonactive;
          }
        }

        &.filteritem-6 {
          border-color: $state-onhold;
          &:hover {
            background-color: $state-onhold;
          }
        }
      }

      button {
        border-color:$brand-grey5;
        color:$brand-black;
        font-size:12px;
        padding:5px 10px;

        &:hover {
          border-color:$brand-red;
          color:$brand-white;
        }

        &:focus {
          outline: none;
        }
      }
      &.selected {
        outline: none;
        button {
          outline: none;
          border-color:$brand-red;
          color:$brand-white;
          background-color:$brand-red;

          &:hover {
            color:$brand-white;
          }

          &.filteritem-1 {
            background-color: $state-pendingapproval;
          }
          &.filteritem-2 {
            background-color: $state-active;
          }
          &.filteritem-3 {
            background-color: $state-pendingfriend;
          }
          &.filteritem-4 {
            background-color: $state-activefriendship;
          }
          &.filteritem-5 {
            background-color: $state-nonactive;
          }
          &.filteritem-6 {
            background-color: $state-onhold;
          }
        }
      }
    }
  }

</style>
